import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface TimeAlert {
  orderId: string;
  orderNumber: string;
  machineName: string | null;
  customerName: string | null;
  quantityPlanned: number;
  unit: string;
  velocidadMPM: number;
  estimatedMinutes: number;
  elapsedMinutes: number;
  estimatedFormatted: string;
  elapsedFormatted: string;
  isExceeded: boolean;
  overageMinutes: number;
  overageFormatted: string | null;
  progressPct: number;
  actualStartDate: string;
}

export interface ProcessAlert {
  routeId: string;
  process: string;
  orderId: string;
  orderNumber: string;
  customerName: string | null;
  machineName: string | null;
  quantityPlanned: number;
  unit: string;
  velocidadMPM: number;
  tiempoPreparacionMin: number;
  estimatedMinutes: number;
  elapsedMinutes: number;
  estimatedFormatted: string;
  elapsedFormatted: string;
  isExceeded: boolean;
  overageMinutes: number;
  overageFormatted: string | null;
  progressPct: number;
  startedAt: string;
}

export interface TimeAlertsResponse {
  alerts: TimeAlert[];
  processAlerts: ProcessAlert[];
}

export function useTimeAlerts() {
  return useQuery<TimeAlertsResponse>({
    queryKey: ['time-alerts'],
    queryFn: async () => {
      const response = await axios.get<{ success: boolean; data: TimeAlert[]; processAlerts: ProcessAlert[] }>('/api/time-alerts');
      return {
        alerts: response.data.data,
        processAlerts: response.data.processAlerts || [],
      };
    },
    refetchInterval: 30000,
    staleTime: 15000,
  });
}
